import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const MoneyConceptScenario = () => {
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(1)
  const [selectedMoneyUse, setSelectedMoneyUse] = useState(null)
  const [coinsSorted, setCoinsSorted] = useState(false)
  const [selectedMoneySource, setSelectedMoneySource] = useState(null)
  const [showFeedback, setShowFeedback] = useState(false)
  const [feedbackMessage, setFeedbackMessage] = useState('')

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-green-50">
      
      {/* Header */}
      <div className="bg-gradient-to-r from-yellow-600 to-yellow-500 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-medium text-yellow-100 mb-1">Interaktívny scenár</div>
                <h1 className="text-3xl font-bold">💰 Čo sú peniaze</h1>
              </div>
              {currentStep === 1 ? (
                <button
                  onClick={() => navigate('/scenarios')}
                  className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium"
                >
                  ← Späť na ročníky
                </button>
              ) : (
                <button
                  onClick={() => setCurrentStep(currentStep - 1)}
                  className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium"
                >
                  ← Späť
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Progress indicator */}
      <div className="bg-white border-b border-gray-200 py-3">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center gap-2">
              {[...Array(13)].map((_, idx) => (
                <div
                  key={idx + 1}
                  className={`flex-1 h-2 rounded-full transition-all ${
                    idx + 1 <= currentStep ? 'bg-yellow-500' : 'bg-gray-200'
                  }`}
                />
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-2 text-center">
              Krok {currentStep} z 13
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">


          {/* NEW INTRO SLIDE 1: What this story is about */}
          {currentStep === 1 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">📖</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  O čom bude tento príbeh?
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto">
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">💭</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Peniaze nám pomáhajú rozhodovať sa
                      </p>
                      <p className="text-gray-600 text-sm">
                        Musíme si vybrať, čo je pre nás dôležitejšie
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">💰</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Peniaze sú obmedzené
                      </p>
                      <p className="text-gray-600 text-sm">
                        Nemôžeme si kúpiť všetko naraz
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">⏳</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Niekedy je lepšie počkať
                      </p>
                      <p className="text-gray-600 text-sm">
                        Ak minieme všetko hneď, neskôr nám môže niečo dôležité chýbať
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* NEW INTRO SLIDE 2: What to notice in the story */}
          {currentStep === 12 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">👀</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Na čo sa v príbehu pozri
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto">
                <div className="bg-purple-50 border-l-4 border-purple-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">🎯</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Čo chcem TERAZ
                      </p>
                      <p className="text-gray-600 text-sm">
                        Čo ma láka hneď, čo by som si kúpil okamžite
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-orange-50 border-l-4 border-orange-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">⚠️</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Čo môže byť dôležitejšie NESKÔR
                      </p>
                      <p className="text-gray-600 text-sm">
                        Na čo budem potrebovať peniaze zajtra alebo o týždeň
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg">
                  <div className="flex items-start gap-3">
                    <div className="text-2xl">🚫</div>
                    <div>
                      <p className="text-gray-700 font-medium mb-2">
                        Čo sa stane, ak miniem všetko hneď
                      </p>
                      <p className="text-gray-600 text-sm">
                        Ak nič neušetrím, budem mať neskôr problém
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(13)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Začnime príbeh
                </button>
              </div>
            </div>
          )}

          {/* ORIGINAL Step 1 (now Step 3): Situation Setup */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">💰</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Máš 5 eur – čo urobíš?
                </h2>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-6 max-w-2xl mx-auto">
                <p className="text-gray-700 mb-3">
                  Tvoja babka ti dala <strong className="text-yellow-600">5 eur</strong> na vreckové.
                </p>
                <p className="text-gray-700">
                  V škole sa začína projekt a potrebuješ <strong>farebné fixky</strong>. Ale v bufete vidíš tvoju obľúbenú čokoládu a hračkárstvo má novú hračku, ktorú si už dlho chceš!
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg max-w-2xl mx-auto">
                <p className="text-gray-700 text-sm">
                  💡 <strong>Otázka:</strong> Môžeš si kúpiť všetko naraz?
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Intro Slide 2: Understanding the problem */}
          {currentStep === 12 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">🤔</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Pozrime sa na ceny
                </h2>
              </div>

              <div className="grid md:grid-cols-3 gap-4 max-w-3xl mx-auto mb-6">
                <div className="bg-purple-50 border-2 border-purple-300 rounded-xl p-4 text-center">
                  <div className="text-4xl mb-2">🖍️</div>
                  <div className="font-bold text-gray-800 mb-1">Farebné fixky</div>
                  <div className="text-2xl font-bold text-purple-600">3,50 €</div>
                  <p className="text-xs text-gray-600 mt-1">Potrebuješ na projekt</p>
                </div>

                <div className="bg-orange-50 border-2 border-orange-300 rounded-xl p-4 text-center">
                  <div className="text-4xl mb-2">🍫</div>
                  <div className="font-bold text-gray-800 mb-1">Čokoláda</div>
                  <div className="text-2xl font-bold text-orange-600">1,50 €</div>
                  <p className="text-xs text-gray-600 mt-1">Tvoja obľúbená</p>
                </div>

                <div className="bg-blue-50 border-2 border-blue-300 rounded-xl p-4 text-center">
                  <div className="text-4xl mb-2">🎮</div>
                  <div className="font-bold text-gray-800 mb-1">Malá hračka</div>
                  <div className="text-2xl font-bold text-blue-600">4,00 €</div>
                  <p className="text-xs text-gray-600 mt-1">Chceš ju už dlho</p>
                </div>
              </div>

              <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg max-w-2xl mx-auto">
                <p className="text-gray-700 mb-2">
                  <strong>Problém:</strong> Máš len <strong className="text-red-600">5 eur</strong>.
                </p>
                <p className="text-gray-700">
                  Ak spočítaš všetko: 3,50 € + 1,50 € + 4,00 € = <strong>9 eur</strong>. To je viac, než máš!
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(13)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Intro Slide 3: Key Learning Point */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center">
              <div className="text-6xl mb-6">💡</div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                Peniaze sú obmedzené
              </h2>
              <div className="max-w-2xl mx-auto">
                <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                  To znamená, že nemôžeš si kúpiť všetko naraz. Musíš sa rozhodnúť, čo je teraz dôležitejšie.
                </p>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  Tvoje rozhodnutie bude mať dôsledky – ak minuteš peniaze na niečo, nebudeš mať na niečo iné.
                </p>
              </div>
              <button
                onClick={() => setCurrentStep(12)}
                className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition shadow-lg"
              >
                Začať rozhodovanie
              </button>
            </div>
          )}

          {/* Step 4: First Decision - What to buy first? */}
          {currentStep === 12 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">🤔</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Čo si kúpiš ako prvé?
                </h2>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700">
                  Máš <strong className="text-yellow-600">5 eur</strong>. Nemôžeš si kúpiť všetko. Musíš sa rozhodnúť – čo je teraz najdôležitejšie?
                </p>
              </div>

              <div className="space-y-4">
                <button
                  onClick={() => {
                    setSelectedMoneyUse('markers')
                    setCurrentStep(13)
                  }}
                  className="w-full p-6 bg-gradient-to-r from-purple-50 to-purple-100 rounded-xl border-2 border-purple-300 hover:border-purple-500 hover:shadow-lg transition-all text-left"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-5xl">🖍️</span>
                    <div>
                      <div className="text-xl font-bold text-gray-800 mb-1">Fixky na projekt (3,50 €)</div>
                      <p className="text-sm text-gray-600">Potrebuješ ich zajtra do školy</p>
                    </div>
                  </div>
                </button>

                <button
                  onClick={() => {
                    setSelectedMoneyUse('chocolate')
                    setCurrentStep(12)
                  }}
                  className="w-full p-6 bg-gradient-to-r from-orange-50 to-orange-100 rounded-xl border-2 border-orange-300 hover:border-orange-500 hover:shadow-lg transition-all text-left"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-5xl">🍫</span>
                    <div>
                      <div className="text-xl font-bold text-gray-800 mb-1">Čokoládu (1,50 €)</div>
                      <p className="text-sm text-gray-600">Máš na ňu chuť teraz</p>
                    </div>
                  </div>
                </button>

                <button
                  onClick={() => {
                    setSelectedMoneyUse('toy')
                    setCurrentStep(13)
                  }}
                  className="w-full p-6 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl border-2 border-blue-300 hover:border-blue-500 hover:shadow-lg transition-all text-left"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-5xl">🎮</span>
                    <div>
                      <div className="text-xl font-bold text-gray-800 mb-1">Hračku (4,00 €)</div>
                      <p className="text-sm text-gray-600">Chceš ju už veľmi dlho</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          )}

          {/* Step 5: Consequence - Chose markers */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">🖍️</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Kúpil si fixky
                </h2>
              </div>

              <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Fixky stoja <strong>3,50 €</strong>. Zaplatil si a zostáva ti <strong className="text-green-600">1,50 €</strong>.
                </p>
                <p className="text-gray-700">
                  ✅ Zajtra v škole budeš môcť robiť projekt! Učiteľka bude spokojná.
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Čo teraz môžeš ešte kúpiť?</strong>
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li>• Čokoláda (1,50 €) – <span className="text-green-600 font-semibold">Áno, máš dosť!</span></li>
                  <li>• Hračka (4,00 €) – <span className="text-red-600 font-semibold">Nie, to je viac než máš</span></li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                <p className="text-gray-700 text-sm">
                  💡 Rozhodol si sa dobre – fixky potrebuješ do školy. Čokoládu si môžeš kúpiť inokedy, alebo ju dostaneš doma.
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 6: Consequence - Chose chocolate */}
          {currentStep === 12 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">🍫</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Kúpil si čokoládu
                </h2>
              </div>

              <div className="bg-orange-50 border-l-4 border-orange-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Čokoláda stojí <strong>1,50 €</strong>. Zaplatil si a zostáva ti <strong className="text-orange-600">3,50 €</strong>.
                </p>
                <p className="text-gray-700">
                  😋 Bola veľmi dobrá! Ale zajtra máš projekt...
                </p>
              </div>

              <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Problém:</strong> Zajtra v škole potrebuješ fixky na projekt.
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li>• Fixky stoja 3,50 € – <span className="text-orange-600 font-semibold">Máš presne toľko!</span></li>
                  <li>• Ale už si minul peniaze na čokoládu, takže by si teraz mal len 3,50 € na fixky</li>
                  <li>• Hračku už si kúpiť nemôžeš (4,00 € je viac, než máš)</li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                <p className="text-gray-700 text-sm">
                  💡 Čokoláda bola dobrá, ale teraz máš menej peňazí. Niekedy je lepšie kúpiť si najprv to, čo naozaj potrebuješ, a potom niečo na zábavu.
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 7: Consequence - Chose toy */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">🎮</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Kúpil si hračku
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Hračka stojí <strong>4,00 €</strong>. Zaplatil si a zostáva ti <strong className="text-blue-600">1,00 €</strong>.
                </p>
                <p className="text-gray-700">
                  🎉 Super! Máš novú hračku, ktorú si chcel!
                </p>
              </div>

              <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>Ale pozor:</strong> Zajtra v škole máš projekt a potrebuješ fixky.
                </p>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li>• Fixky stoja 3,50 € – <span className="text-red-600 font-semibold">Máš len 1 euro, to nestačí!</span></li>
                  <li>• Čokoládu si tiež nemôžeš kúpiť (stojí 1,50 €)</li>
                  <li>• Zajtra v škole budeš mať problém, lebo nebudeš mať fixky na projekt</li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                <p className="text-gray-700 text-sm">
                  💡 Hračka je fajn, ale niekedy musíme najprv myslieť na to, čo naozaj potrebujeme. Hračku by si si mohol kúpiť neskôr, keď budeš mať znova peniaze.
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 8: Discussion - Where do people get money? */}
          {currentStep === 12 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-5xl mb-4">💬</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Prečo je dôležité rozmýšľať?
                </h2>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-4">
                  <strong>Zistili sme:</strong>
                </p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold">•</span>
                    <span>Keď máš obmedzené peniaze, nemôžeš si kúpiť všetko naraz</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold">•</span>
                    <span>Tvoje rozhodnutie má dôsledky – ak minuteš peniaze na jedno, nebudeš mať na druhé</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold">•</span>
                    <span>Niekedy je múdrejšie kúpiť si najprv to, čo naozaj potrebuješ</span>
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded-lg mb-6">
                <p className="text-gray-700 text-sm">
                  💡 To neznamená, že si nemôžeš nič kúpiť len tak pre radosť! Ale je dobré najprv sa pýtať: „Čo naozaj potrebujem? Čo môže počkať?"
                </p>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(13)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 9: Another Scenario - Next week */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">📅</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  O týždeň neskôr...
                </h2>
              </div>

              <div className="bg-purple-50 border-l-4 border-purple-400 p-6 rounded-lg mb-6">
                <p className="text-gray-700 mb-3">
                  Tvoj otec ti dáva znova <strong className="text-purple-600">5 eur</strong> na vreckové.
                </p>
                <p className="text-gray-700">
                  Tentoraz fixky už máš. V obchode vidíš novú knihu komiksu (<strong>4,50 €</strong>) a pri pokladni leží tvoja obľúbená žuvačka (<strong>0,50 €</strong>).
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
                <p className="text-gray-700 text-sm">
                  💡 <strong>Otázka:</strong> Môžeš si kúpiť oboje? Spočítaj: 4,50 € + 0,50 € = 5,00 € – áno, presne toľko máš!
                </p>
              </div>

              <div className="text-center mt-8">
                <button
                  onClick={() => setCurrentStep(12)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Pokračovať
                </button>
              </div>
            </div>
          )}

          {/* Step 10: Summary */}
          {currentStep === 12 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">✨</div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Čo si sa naučil?
                </h2>
              </div>

              <div className="space-y-4 max-w-2xl mx-auto mb-8">
                <div className="bg-blue-50 border-l-4 border-blue-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">1. Peniaze sú obmedzené</h3>
                  <p className="text-gray-700 text-sm">
                    Nemôžeš si kúpiť všetko naraz. Musíš sa rozhodnúť, čo je teraz najdôležitejšie.
                  </p>
                </div>

                <div className="bg-green-50 border-l-4 border-green-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">2. Rozhodnutia majú dôsledky</h3>
                  <p className="text-gray-700 text-sm">
                    Ak minuteš peniaze na niečo, nebudeš mať na niečo iné. Preto je dobré premýšľať pred tým, ako si niečo kúpiš.
                  </p>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-5 rounded-lg">
                  <h3 className="font-bold text-gray-900 mb-2">3. Potreby vs. chcenia</h3>
                  <p className="text-gray-700 text-sm">
                    Niekedy je múdrejšie kúpiť si najprv to, čo naozaj potrebuješ (ako fixky do školy). Niečo zábavné si môžeš kúpiť potom, keď budeš mať znova peniaze.
                  </p>
                </div>
              </div>

              <div className="text-center">
                <button
                  onClick={() => setCurrentStep(13)}
                  className="px-8 py-4 bg-yellow-600 text-white rounded-xl font-bold text-lg hover:bg-yellow-700 transition"
                >
                  Ukončiť
                </button>
              </div>
            </div>
          )}

          {/* Step 11: Final discussion */}
          {currentStep === 13 && (
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center">
              <div className="text-6xl mb-6">🎉</div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Scenár dokončený!
              </h2>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg max-w-2xl mx-auto mb-8">
                <h3 className="font-bold text-gray-900 mb-4">💬 Diskusia do triedy:</h3>
                <ul className="space-y-3 text-sm text-gray-700 text-left">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Kedy si musel niečo počkať, lebo si nemal dosť peňazí?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Čo by sa stalo, keby si minul všetky peniaze na sladkosti?</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-600 font-bold mt-1">•</span>
                    <span>Ako vieš rozpoznať, čo naozaj potrebuješ a čo len chceš?</span>
                  </li>
                </ul>
              </div>

              <div className="flex gap-4 justify-center">
                <button
                  onClick={() => {
                    setCurrentStep(1)
                    setSelectedMoneyUse(null)
                    setCoinsSorted(false)
                    setSelectedMoneySource(null)
                  }}
                  className="px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition"
                >
                  🔄 Skúsiť znova
                </button>
                <button
                  onClick={() => navigate('/scenarios')}
                  className="px-6 py-3 bg-yellow-600 text-white rounded-xl font-semibold hover:bg-yellow-700 transition"
                >
                  Späť na ročníky
                </button>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  )
}

export default MoneyConceptScenario
